import { render, staticRenderFns } from "./ConfirmDeleteModalGroup.vue?vue&type=template&id=4958967c&"
import script from "./ConfirmDeleteModalGroup.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteModalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports